import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Container from "../components/Container";

function getYouTubeId(url = "") {
  return url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/)?.[1] || "";
}

export default function News() {
  const [section, setSection] = useState({ items: [] });

  useEffect(() => {
    fetch("/data/homepage.json").then((response) => response.json()).then((data) => {
      setSection((data.sections || []).find((item) => item.type === "news") || { items: [] });
    }).catch(console.error);
  }, []);

  return (
    <main>
      <section className="border-b border-[#ddd8ce] bg-[#222720] py-14 text-white sm:py-20">
        <Container>
          <p className="text-sm font-bold text-[#c9aa70]">أخبار الرعية</p>
          <h1 className="mt-3 text-[40px] font-extrabold sm:text-[56px]">جميع الأخبار</h1>
          <p className="mt-5 max-w-2xl leading-8 text-white/70">تابع أخبار الرعية، مناسباتها، فيديوهاتها ومحطات من أرشيفها المصوّر.</p>
        </Container>
      </section>
      <section className="bg-[#faf9f6] py-14 sm:py-20">
        <Container>
          <div className="flex flex-col gap-6">
            {(section.items || []).map((item) => {
              const videoId = getYouTubeId(item.youtubeUrl);
              const image = item.coverImage || item.photos?.[0]?.image || (videoId ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg` : "");
              const hasArticle = Boolean(item.slug);
              const media = image && <img src={image} alt={item.imageAlt || item.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" loading="lazy" />;
              return (
                <article key={item.slug || item.youtubeUrl || item.title} className="group grid overflow-hidden border border-[#dcd7cd] bg-white md:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)]">
                  {hasArticle ? (
                    <Link to={`/news/${item.slug}`} className="block aspect-video overflow-hidden bg-[#e8e5de] md:aspect-auto md:min-h-72">{media}</Link>
                  ) : (
                    <a href={item.youtubeUrl} target="_blank" rel="noreferrer" className="block aspect-video overflow-hidden bg-[#e8e5de] md:aspect-auto md:min-h-72" aria-label={`مشاهدة ${item.title} على يوتيوب`}>{media}</a>
                  )}
                  <div className="flex flex-col justify-center p-6 sm:p-8">
                    <div className="flex gap-3 text-xs font-bold text-[#9a763d]"><span>{item.mediaType === "video" ? "فيديو" : "ألبوم صور"}</span>{item.date && <time>{item.date}</time>}</div>
                    <h2 className="mt-3 text-2xl font-bold leading-[1.55] text-[#252923] sm:text-[30px]">{hasArticle ? <Link to={`/news/${item.slug}`}>{item.title}</Link> : item.title}</h2>
                    {item.summary && <p className="mt-3 line-clamp-3 text-sm leading-7 text-[#686b65]">{item.summary}</p>}
                    {hasArticle ? (
                      <Link to={`/news/${item.slug}`} className="mt-6 inline-block text-sm font-bold text-[#8d6b35]">قراءة الخبر ←</Link>
                    ) : (
                      <a href={item.youtubeUrl} target="_blank" rel="noreferrer" className="mt-6 inline-block text-sm font-bold text-[#8d6b35]">مشاهدة الفيديو على يوتيوب ←</a>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </Container>
      </section>
    </main>
  );
}
